import { List, Text } from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { Card } from "../../components/Card";

const AssessorsCard = ({ offering }) => {
  const { t } = useTranslation();
  const assessors = [...new Set(offering.evidence[0].assessor_ids)];

  return (
    assessors.length > 0 && (
      <Card
        style={{
          backgroundColor: "#F2F8FA",
          height: "auto",
          marginTop: "1rem",
        }}
      >
        <Text weight="bold">{t("assessment.courseAssessors")}: </Text>
        <List>
          {assessors.map((assessor) => (
            <List.Item key={assessor}>{assessor}</List.Item>
          ))}
        </List>
      </Card>
    )
  );
};

export default AssessorsCard;
